import * as z from 'zod';
import { Timestamp } from '@angular/fire/firestore';

/** Converts a `Date` or `Timestamp` to `Date` */
export const DateTimestampToDateAngularSchema = z
  .union([z.instanceof(Date), z.instanceof(Timestamp)])
  .transform((val) => (val instanceof Date ? val : val.toDate()));

/** @alias `Date` */
export type DateTimestampAngular = z.infer<
  typeof DateTimestampToDateAngularSchema
>;

/** Converts a `Date` or `Timestamp` or `null`, to either `Date` or `null`. */
export const DateTimestampNullToDateNullAngularSchema = z
  .union([z.instanceof(Date), z.instanceof(Timestamp), z.null()])
  .transform((val) =>
    val === null ? null : val instanceof Date ? val : val.toDate(),
  );

/** @alias `Date | null` */
export type DateTimestampNullToDateNullAngular = z.infer<
  typeof DateTimestampNullToDateNullAngularSchema
>;
